const Styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  box: {
    display: "flex",
    flexDirection: "column",
    gap: "30px",
    alignItems: "center",
    justifyContent: "flex-start",
    borderRadius: "4px",
    border: "1px solid rgb(129, 167, 232)",
    background: "rgb(218, 231, 254)",
    padding: "20px",
    width: "50%",
  },
  filename: {
    fontSize: "25px",
    fontWeight: "600",
    margin: "0 0",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%",
    alignItems: "flex-start",
  },
  uploadBox: {
    border: "1px dashed black",
    display: "flex",
    flexDirection: "column",
    gap: "50px",
    alignItems: "center",
    width: "80%",
    padding: "20px 0px",
    borderRadius: "4px",
  },
};

export default Styles;
